/** The root account's role: a system role no member can be given. */
export const OWNER_ROLE = 'OWNER';
export const ORG_SEGMENTS = [
    'PRIVATE_LANDLORD',
    'MANAGEMENT_COMPANY',
    'AGENCY'
];
/** The segment of an organization that has no row yet, as in the schema default. */
export const DEFAULT_SEGMENT = 'PRIVATE_LANDLORD';
export const ACTIONS = ['read', 'create', 'update', 'delete', 'assign'];
/**
 * Prisma models covered by access rules. `Account` stands for the members of
 * the organization's team; `Organization` is the caller's own organization.
 * `Invoice` and `Transaction` are the finances: invoices of rentals and the
 * payments recorded against them. `Contact` is the organization's contacts:
 * clients, tenants, owners. `Document` is a document attached to a deal, a
 * rental, a property or a contact, and follows it. `Task` is a member's task,
 * set by whoever created it for whoever is responsible. `ExternalListing` is
 * a property's listing on a marketplace or the site, and follows the property.
 * `BuildProfile` is a mobile app the organization builds with the app builder.
 * `RentalAutomation` is a rental's automation (invoices, reminders), and
 * follows the rental. `StudioChat` is a member's site-builder project for a
 * property in the studio; creating one is using the studio at all.
 */
export const RESOURCES = [
    'Deal',
    'Account',
    'Organization',
    'Property',
    'Rental',
    'Invoice',
    'Transaction',
    'Contact',
    'Document',
    'Task',
    'ExternalListing',
    'BuildProfile',
    'RentalAutomation',
    'StudioChat'
];
